import { Card, CardContent, CardMedia, Chip, Grid, Tooltip, Typography, withStyles } from '@material-ui/core';
import { useTheme } from '@material-ui/core/styles';
import clsx from 'clsx';
import useStyles from './styles';

const levels = {
  all: {
    color: 'green',
    label: 'Tout niveau',
  },
  beginner: {
    color: 'green',
    label: 'Débutant',
  },
  expert: {
    color: 'red',
    label: 'Expert',
  },
  intermediate: {
    color: 'orange',
    label: 'Intermédiaire',
  },
};

const StyledTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: '#f5f5f9',
    color: theme.palette.text.primary,
    maxWidth: 220,
    fontSize: theme.typography.pxToRem(12),
    border: '1px solid #dadde9',
  },
}))(Tooltip);

const ActivityDragCard = ({ activity }) => {
  const classes = useStyles();
  const theme = useTheme();

  const stringDuration = `${Math.floor(activity.duration / 60)
    .toString()
    .padStart(2, '0')}:${(activity.duration % 60).toString().padStart(2, '0')}`;
  const dataEvent = {
    title: activity.text,
    duration: stringDuration,
    service_id: activity.service_id,
    is_blocked: activity.is_blocked,
  };

  return (
    <StyledTooltip
      title={
        activity.is_blocked ? (
          <Typography>Vous ne pouvez pas ajouter un créneau pour une activité bloquée !</Typography>
        ) : (
          ''
        )
      }
      placement="left"
    >
      <Card
        id="serviceCard"
        className={classes.root}
        data-event={JSON.stringify(dataEvent)}
        style={{ opacity: activity.is_blocked ? 0.6 : 1 }}
      >
        <CardMedia className={classes.media} component="img" src={activity.img} alt="Activity" />
        <CardContent className={classes.content}>
          <Grid container spacing={1}>
            <Grid item xs={7}>
              <Typography className={classes.title}>Nom</Typography>
              <Typography className={clsx(classes.text, classes.cutText)}>{activity.text}</Typography>
            </Grid>

            <Grid item xs={5}>
              <Typography className={classes.title}>Type</Typography>
              <Typography className={classes.text}>{activity.courseType}</Typography>
            </Grid>
          </Grid>

          <Grid container spacing={1}>
            <Grid item xs={7}>
              <Typography className={classes.title}>Niveau</Typography>
              <Chip
                className={classes.chip}
                label={levels[activity.level].label}
                style={{ backgroundColor: theme.palette.chips[levels[activity.level].color] }}
              />
            </Grid>

            <Grid item xs={5}>
              <Typography className={classes.title}>Prix TTC</Typography>
              <Typography className={classes.text}>{activity.peakPrice} €</Typography>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </StyledTooltip>
  );
};

export default ActivityDragCard;
